/**
 * Enable chat to multiple locales
 */
export const HELP_CENTER_ENABLE_LOCALES = 'HELP_CENTER_ENABLE_LOCALES';
